// removed by extract-text-webpack-plugin
module.exports = {"autocomplete_item":"_1JP3A","noSearch":"_3s5PR","highlighted":"_1IjxU"};


//////////////////
// WEBPACK FOOTER
// ./components/AutocompleteItem/styles.scss
// module id = 598
// module chunks = 0